import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useContext } from 'react';
import { OverlayTriggerStateContext } from 'react-aria-components';
import { IconButton } from '../../buttons/IconButton/IconButton.js';
import { XIcon } from '../../icons/XIcon.js';
/**
 * Close button for a RAC overlay.
 */
export const OverlayCloseButton = forwardRef(function OverlayCloseButton(props, forwardedRef) {
    const state = useContext(OverlayTriggerStateContext);
    return (_jsx(IconButton, { ...props, ref: forwardedRef, variant: "subtle", onPress: (e) => {
            state?.close();
            props.onPress?.(e);
        }, children: _jsx(XIcon, {}) }));
});
//# sourceMappingURL=OverlayCloseButton.js.map